import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import projectsData from '../Data/ProjectsData';

function ProjectDetailPage() {
    const { id } = useParams();
    const [project, setProject] = useState(null);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    useEffect(() => {
        window.scrollTo(0, 0);
        const foundProject = projectsData.find(p => p.id === parseInt(id));
        setProject(foundProject);
    }, [id]);

    if (!project) {
        return (
            <div className="container py-5 text-center">
                <div className="py-5">
                    <h2>المشروع غير موجود</h2>
                    <p className="mt-3">لم يتم العثور على المشروع المطلوب.</p>
                    <Link to="/" className="btn btn-primary mt-3">العودة للصفحة الرئيسية</Link>
                </div>
            </div>
        );
    }

    return (
        <div className="container py-5">
            <nav aria-label="breadcrumb" className="mt-4">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item"><Link to="/" state={{scrollTo:'hero'}}>الرئيسية</Link></li>
                    <li className="breadcrumb-item"><Link to="/" state={{scrollTo:'projects'}}>المشاريع</Link></li>
                    <li className="breadcrumb-item active" aria-current="page">{project.title}</li>
                </ol>
            </nav>

            <div className="row mt-4">
                <div className="col-lg-8">
                    <div id="projectCarousel" className="carousel slide mb-4 rounded overflow-hidden shadow-sm" data-bs-ride="carousel">
                        <div className="carousel-inner">
                            {project.screenshots.map((screenshot, index) => (
                                <div key={index} className={`carousel-item ${index === currentImageIndex ? 'active' : ''}`} >
                                    <img src={screenshot} className="d-block w-100" alt={`لقطة ${index+1}`} style={{maxHeight: "500px", margin: "0 auto" }} />
                                </div>
                            ))}
                        </div>
                        <button className="carousel-control-prev" type="button" onClick={() => setCurrentImageIndex((currentImageIndex - 1 + project.screenshots.length) % project.screenshots.length)}>
                            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">السابق</span>
                        </button>
                        <button className="carousel-control-next" type="button" onClick={() => setCurrentImageIndex((currentImageIndex + 1) % project.screenshots.length)}>
                            <span className="carousel-control-next-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">التالي</span>
                        </button>
                    </div>

                    <h1 className="fw-bold mb-4">{project.title}</h1>
                   
                    <div className=" p-4 rounded-3 mb-4">
                        <h4 className="fw-bold mb-3">تفاصيل المشروع</h4>
                        <div dangerouslySetInnerHTML={{ __html: project.fullDescription }}></div>
                    </div>
                </div>

                <div className="col-lg-4">
                    <div className="card shadow-sm rounded-3 border-0 sticky-lg-top" style={{ top: '100px' }}>
                        <div className="card-body">
                            <h5 className="card-title fw-bold mb-3">معلومات المشروع</h5>
                           
                            <div className="mb-4">
                                <div className="d-flex align-items-center mb-3">
                                    <div className={`${project.gradient} text-white rounded-circle p-2 me-3`} style={{ width: '40px', height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <i className={project.icon}></i>
                                    </div>
                                    <div>
                                        <h6 className="fw-bold mb-0">{project.title}</h6>
                                    </div>
                                </div>
                            </div>
                           
                            <div className="d-grid gap-2 mb-4">
                                {project.demoUrl && (
                                    <a href={project.demoUrl} target="_blank" rel="noopener noreferrer" className="btn btn-primary">
                                        <i className="fas fa-play-circle me-2"></i> عرض المشروع
                                    </a>
                                )}
                                {project.codeUrl && (
                                    <a href={project.codeUrl} target="_blank" rel="noopener noreferrer" className="btn btn-outline-secondary">
                                        <i className="fab fa-github me-2"></i> رمز المصدر
                                    </a>
                                )}
                            </div>
                           
                            <div className="mb-3">
                                <h6 className="fw-bold mb-2">التقنيات المستخدمة:</h6>
                                <div className="d-flex flex-wrap gap-1">
                                    {project.tags.map((tag, index) => (
                                        <span key={index} className="badge bg-light text-dark">{tag}</span>
                                    ))}
                                </div>
                            </div>
                           
                            <Link className="d-block text-center mt-4" to="/" state={{scrollTo:'projects'}}>
                                <i className="fas fa-arrow-right me-1"></i> العودة إلى جميع المشاريع
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ProjectDetailPage;